module.exports = __webpack_public_path__ + "img/sea-6.eeb61ead.jpg";